// #JOB_CLOSE_GATE_V1 (2026-10-05) — Bill: "Trailing cost occurs but we need to have a confirmation and
// cut off for Override when jobs close... Maybe 14 days past ok but anything more should flag for
// override to hit close / completed job."
//
// One rule, one place, so every screen that charges cost to a job reads a closed job the same way:
//   job not Complete / Cancelled ............ open — post normally
//   closed 0–14 days ago .................... 'grace'    — trailing cost, allowed after a confirm
//   closed more than 14 days ago ............ 'override' — blocked until an Owner overrides with a reason
//   closed, but no readable close date ...... 'override' — can't prove it is inside the window
//
// The clock runs from the job's completion stamp on the Job List (act_com — "MM/DD/YY", "YYYY-MM-DD",
// or "CXL MM/DD/YY" on a cancelled job) to TODAY, the day the cost is being posted: the point of the
// cutoff is to stop a closed job's numbers moving without someone signing off, whatever the invoice date.
export const JOB_CLOSE_GRACE_DAYS = 14;
const CLOSED_STATS = ['Complete', 'Cancelled'];

export function jobCloseDate(j) {
  const v = String((j && j.act_com) || '');
  let y, m, d;
  const iso = v.match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (iso) { y = +iso[1]; m = +iso[2]; d = +iso[3]; }
  else {
    const mdy = v.match(/(\d{1,2})\/(\d{1,2})\/(\d{2,4})/);
    if (!mdy) return null;
    m = +mdy[1]; d = +mdy[2]; y = +mdy[3]; if (mdy[3].length <= 2) y += 2000;
  }
  const dt = new Date(y, m - 1, d, 12);
  return (dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d) ? dt : null;
}

// → { closed:false, level:'open', stat }
//   { closed:true,  level:'grace'|'override', stat, date, days, label }   (date/days null + label '' when unknown)
export function jobCloseCheck(j, now = new Date(), grace = JOB_CLOSE_GRACE_DAYS) {
  const stat = String((j && j.stat) || '');
  if (!j || !CLOSED_STATS.includes(stat)) return { closed: false, level: 'open', stat };
  const date = jobCloseDate(j);
  if (!date) return { closed: true, level: 'override', stat, date: null, days: null, label: '' };
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12);
  const days = Math.max(0, Math.round((today - date) / 86400000));
  const label = `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${String(date.getFullYear()).slice(-2)}`;
  return { closed: true, level: days <= grace ? 'grace' : 'override', stat, date, days, label };
}
